import { runWithAdal } from 'react-adal'

import { authContext } from './adalConfig'

const DO_NOT_LOGIN = false

if (process.env.NODE_ENV !== 'development' || process.env.REACT_APP_SSO_TEST_MODE === 'true') {
  runWithAdal(authContext, () => {
    require('./App.tsx')
  }, DO_NOT_LOGIN)
} else {
  // tslint:disable no-var-requires
  require('./App.tsx')
}
